'use client';

import Script from 'next/script';

declare global {
  interface Window { anj_1d4f86fd_7190_4f0e_9c0c_489e7aa1f045?: { init: () => void; }; }
}

const SCRIPT_SRC = 'https://d8eac85a-6ddc-4b18-bc18-8d7627783300.snippet.anjouangaming.org/anj-seal.js';

export default function SealScriptLoader() {
  return (
    <Script
      src={SCRIPT_SRC}
      strategy="lazyOnload"
      onLoad={() => {
        window.anj_1d4f86fd_7190_4f0e_9c0c_489e7aa1f045?.init();
      }}
    />
  );
}
